import pertoLogo from "../../images/perto-logo.png";

export default function Header({ userName, history }) {
  return (
    <div style={{display: 'flex', backgroundColor: '#04b53f', paddingTop: 10, padding: 5, alignItems: 'center'}}>
        <img
          src={pertoLogo}
          alt=""
          style={{ height: 40, width: 80, marginRight: 15, marginTop: 5}}
        />
      <h4 style={{ color: "white", fontWeight: "bolder" }}>Perto Educação - Pedido da escola</h4>
    </div>    
  );
}